const mediaItems = [
  {
    title: '如何使用在线吃瓜多线路入口',
    desc: '详细介绍在线吃瓜线路一、备用网址及官方线路的访问方法与切换技巧',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20user%20guide%20concept%20with%20glowing%20pathways%2C%20dark%20background%2C%20warm%20amber%20accent%20lighting%2C%20minimalist%20digital%20illustration%2C%20tutorial%20visual%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=media-guide-01&orientation=landscape',
    icon: 'ri-play-circle-line',
    label: '使用教程',
  },
  {
    title: '在线吃瓜安全访问全攻略',
    desc: '从DNS设置到浏览器配置，全面保障访问在线吃瓜入口的安全性与稳定性',
    img: 'https://readdy.ai/api/search-image?query=Security%20shield%20concept%20with%20lock%20icon%2C%20dark%20background%2C%20coral%20and%20amber%20glow%20effects%2C%20cybersecurity%20minimalist%20style%2C%20clean%20geometric%20design&width=800&height=500&seq=media-safety-02&orientation=landscape',
    icon: 'ri-shield-check-line',
    label: '安全指南',
  },
  {
    title: '移动端访问在线吃瓜最佳实践',
    desc: '手机浏览器访问91在线吃瓜网的优化技巧，省流量、速度快、体验好',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20abstract%20content%2C%20dark%20background%2C%20warm%20glowing%20accents%2C%20mobile%20browsing%20concept%2C%20minimalist%20digital%20art%2C%20clean%20modern%20composition&width=800&height=500&seq=media-mobile-03&orientation=landscape',
    icon: 'ri-smartphone-line',
    label: '移动技巧',
  },
  {
    title: '在线吃瓜入口失效快速应对方案',
    desc: '遇到入口打不开时的应急处理流程，多线路切换与备用网址使用详解',
    img: 'https://readdy.ai/api/search-image?query=Emergency%20backup%20concept%20with%20multiple%20connected%20nodes%2C%20dark%20background%2C%20warm%20amber%20and%20coral%20glowing%20connections%2C%20resilience%20theme%2C%20minimalist%20tech%20style&width=800&height=500&seq=media-backup-04&orientation=landscape',
    icon: 'ri-restart-line',
    label: '应急指南',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-film-line text-accent-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">媒体聚焦</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-50 border border-background-300/30 hover:border-accent-500/20 transition-all duration-300 cursor-pointer">
              <div className="aspect-[8/5] overflow-hidden relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 left-3 w-8 h-8 rounded-lg bg-background-50/80 backdrop-blur-sm flex items-center justify-center">
                  <i className={`${item.icon} text-primary-400`}></i>
                </span>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-accent-500/10 text-accent-400 mb-2">{item.label}</span>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}